import cssLonghand from '@team-griffin/css-longhand';
import reduce from 'lodash.reduce';

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _sidesMap;

var Side = {
  A: 'a',
  X: 'x',
  Y: 'y'
};

var actualSides = ['left', 'top', 'right', 'bottom'];

var sidesMap = (_sidesMap = {}, defineProperty(_sidesMap, Side.A, [0, 1, 2, 3]), defineProperty(_sidesMap, Side.X, [0, 2]), defineProperty(_sidesMap, Side.Y, [1, 3]), _sidesMap);

var cssSides = function cssSides(prop, sides, value) {
  return cssLonghand(prop, reduce(sidesMap[sides], function (result, idx) {
    return Object.assign({}, result, defineProperty({}, actualSides[idx], value));
  }, {}));
};

export default cssSides;
export { Side };
